import { LifeStyleQuestion } from './lifestyle.model';
import { QuestionsToAPI, UnderWritingData } from './lifestyle.post.model';

export class RefJsonQuestion {
    questionId: string;
    questionList: LifeStyleQuestion[];
    jsonToRefer: string;
}

export class MedCondClassificationModel {
    subCondition: string;
    classification: string
}

export class MedicationQuestionStoreModel {
    medQuesId: string;
    questionList: QuestionsToAPI[];
    indexToSave: string;
}

export class TabQuesObjList {
    quesToMap: string;
    quesListToStore: MedicationQuestionStoreModel[];
}

export class SaveReturnModel {
    saverAndReturn: boolean;
    redirectUrl: string;

    constructor(saverAndReturn: boolean, redirectUrl: string) {
        this.saverAndReturn = saverAndReturn;
        this.redirectUrl = redirectUrl;
    }
}

export class tabSquareActiveModel {
    isActive: boolean;
    tabQuestionId: string;
    activeIndex: number;
    nextQuestionObjList: LifeStyleQuestion[];
    jsonToRefer: string;
    accordPrefix: string;
}

export class MedCondDashBoard {
    mcName: string;
    status: string;
    index: number;
}

export class SubAndClassificationModel {
    classificationValue: string;
    subConditionList: MedCondClassificationModel;
    mapQuesId: string;

    constructor(classificationValue: string, subConditionList: MedCondClassificationModel, mapQuesId: string) {
        this.classificationValue = classificationValue;
        this.subConditionList = subConditionList;
        this.mapQuesId = mapQuesId;
    }
}

export class CurrentMedConToDisplay {
    tittle: string;
    jsonUrl: string;
    totalMedCondn: number;
}

export class BackDataStoreModel {
    isEdit: boolean;
    currentIndex: number;
    selectedMedCondn: string;
}

export class EditMedIndexModel {
    editIndex: number;
}

export class PayloadObjFromStore {
    payloadObj: UnderWritingData;
    indexNumberToSearch: number;
}

export class DigitsModal {
    minValue: string;
    maxValue: string;
    valueKey: string;
    decimalRange: boolean;
}

export class EmitterToCtlTypeModel {
    valueToPass: string;
    resetNextQuestion: boolean;
    refToTabSquareQuestions: MedicationQuestionStoreModel;
    refToAccordQuestions: AccordQuestionStoreModel;
    accordIndexValue: number;
    toggleBtnFlag: boolean = false;

    constructor(valueToPass: string, resetNextQuestion: boolean, refToTabSquareQuestions: MedicationQuestionStoreModel,
        accordIndexValue: number, refToAccordQuestions: AccordQuestionStoreModel, toggleBtnFlag?: boolean) {
        this.valueToPass = valueToPass;
        this.resetNextQuestion = resetNextQuestion;
        this.refToTabSquareQuestions = refToTabSquareQuestions;
        this.accordIndexValue = accordIndexValue;
        this.refToAccordQuestions = refToAccordQuestions;
        this.toggleBtnFlag = toggleBtnFlag;
    }
}

export class EmitterToCtlTypeModelTabSquare {
    accordIndexValue: number;
    tabIndex: number;
    refToAccordQuestions: AccordQuestionStoreModel;

    constructor(accordIndexValue: number, tabIndex: number, refToAccordQuestions: AccordQuestionStoreModel) {
        this.accordIndexValue = accordIndexValue;
        this.tabIndex = tabIndex;
        this.refToAccordQuestions = refToAccordQuestions;
    }
}

export class AccordBtnModel {
    numberOfAccord: number;
    maxNumberOfAccord: number;
    lastIndexCreated: number;

    constructor(numberOfAccord: number, maxNumberOfAccord: number, lastIndexCreated: number) {
        this.numberOfAccord = numberOfAccord;
        this.maxNumberOfAccord = maxNumberOfAccord;
        this.lastIndexCreated = lastIndexCreated;
    }
}

export class AccordQuestionStoreModel {
    accordionQuesId: string;
    questionList: QuestionsToAPI[];
    accordionIndex: number;
    constructor(accordionQuesId: string, accordionIndex: number, questionList: QuestionsToAPI[], ) {
        this.accordionQuesId = accordionQuesId;
        this.questionList = questionList;
        this.accordionIndex = accordionIndex;
    }
}

export class InvalidCtlNameObj {
    invalidDataPresent: boolean;
    ctlName: string;

    constructor(invalidDataPresent: boolean, ctlName: string) {
        this.invalidDataPresent = invalidDataPresent;
        this.ctlName = ctlName;
    }
}

export class TabSquareMandatoryErrorModel {
    quesIdToMap: string;
    indexNumberList: string[];

    constructor(quesId: string, indexNumberList: string[]) {
        this.quesIdToMap = quesId;
        this.indexNumberList = indexNumberList;
    }
}